import template from './ecocode-trustpilot-invitation-recover.html.twig';

const { Mixin, Utils, Component } = Shopware;

Component.register('ecocode-trustpilot-invitation-recover', {
    template,
    inject: ['ecocodeTrustpilotRecoverInvitationService'],
    mounted() {
        this.updateInvitationsCount();
        this.isLoading = false;
    },
    mixins: [
        Mixin.getByName('notification')
    ],
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },

        salesChannel: {
            required: false,
        },
    },
    data() {
        return {
            isLoading: true,
            isDisabled: false,
            days: 30,
            ordersCount: 0
        };
    },
    watch: {
        days() {
            this.updateInvitationsCount();
        }
    },
    methods: {
        updateInvitationsCount: Utils.debounce(async function updateInvitations() {
            this.isLoading = true;
            this.isDisabled = true;
            const result = await this.ecocodeTrustpilotRecoverInvitationService.recoverInvitationsCount({ days: this.days, salesChannelId: this.salesChannel?.id });
            this.ordersCount = result.count;
            this.isDisabled = false;
            this.isLoading = false;
        }, 400),
        async inviteAction() {
            const data = await this.ecocodeTrustpilotRecoverInvitationService.recoverInvitations({ days: this.days, salesChannelId: this.salesChannel?.id});
            this.isDisabled = true;
            this.createNotificationInfo({
                message: this.$tc('ecocode-trustpilot.invitation.notification', { count: data.count })
            });
        }
    }
});
